(async () => {
  if (!window.location.href.includes('/products/')) {
    return;
  }
  const sharePageButtons = Array.from(document.querySelectorAll('.js-share-current-page'));

  // Generate a simple verification token (combine with server-side validation)
  const generateToken = () => {
    const timestamp = Date.now();
    const randomStr = Math.random().toString(36).substring(2);
    // In production, you'd want to hash this with a secret shared with your server
    return btoa(`${timestamp}-${randomStr}-${window.location.hostname}`);
  };

  for (const sharePageButton of sharePageButtons) {
    sharePageButton.addEventListener('click', (event) => {
      if (!event.isTrusted) {
        return;
      }
      const { origin, pathname } = window.location;
      const pageUrl = `${origin}${pathname}`;
      const verificationToken = generateToken();

      fetch('https://www.fpapplications.com/sharePage', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Share-Token': verificationToken,
          'X-Request-Origin': 'share-button',
        },
        body: JSON.stringify({
          pageUrl,
          timestamp: Date.now(),
        }),
      });
    });
  }
})();
